import { useSyncExternalStore } from "react";

const QUERY = "(min-width: 768px)";

function subscribe(callback) {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", callback);
  return () => mq.removeEventListener("change", callback);
}

function getSnapshot() {
  return window.matchMedia(QUERY).matches;
}

// Mobile-first default: "unknown yet" and "mobile" render identical markup, so
// there's never a desktop/mobile flash on the smaller device that matters most.
function getServerSnapshot() {
  return false;
}

export function useDesktopMode() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
